var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExpand(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.46 2.851c.389.002.704.318.704.708l.002 3.524a.708.708 0 01-.707.709h-.001a.709.709 0 01-.708-.708l-.002-1.83-2.33 2.33a.706.706 0 01-1.002 0 .709.709 0 010-1.001l2.323-2.324-1.826-.009a.71.71 0 01.003-1.416h.004l3.54.017zM6.581 9.416a.708.708 0 111.002 1.002l-2.332 2.331 1.831.001a.708.708 0 110 1.417l-3.524-.002a.708.708 0 01-.708-.705l-.018-3.54a.709.709 0 01.705-.712h.004c.39 0 .706.315.708.705l.01 1.826 2.322-2.323z",
    fill: "current"
  })));
}
export default SvgExpand;